import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useParticipantProfile = ({ participantId }: { participantId: number }) => {
	const queryClient = useQueryClient();
	const queryKey = ["participant-profile", { participantId }];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getParticipantById({
				participantId: participantId,
			});
			return response;
		},

		enabled: !!participantId && participantId > 0,
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
